<template>
  <div :class="$style.formWrapper" data-testid="formWrapper">
    <slot></slot>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.formWrapper {
  background-color: colors.$color-white;
  border-radius: 8px;
  box-shadow: variables.$tableShadow;
}
</style>
